import { ServiceStackBaseState } from './service-stack-base.model';
import { createReducer, on } from '@ngrx/store';
import { zefResetState } from '@zerops/zef/core';
import {
  deleteBackupSuccess,
  getBackupsSuccess,
  getProjectBackupsSuccess,
  getContainerFileSuccess,
  ServiceStackBaseActionUnion,
  setBackupConfigSuccess
} from './service-stack-base.action';

const initialState = new ServiceStackBaseState();

const actionReducer = createReducer(
  initialState,
  on(
    getContainerFileSuccess,
    (s, { data, originalAction }): ServiceStackBaseState => {
      const serviceStackFiles = s.containerFiles?.[originalAction?.data?.serviceStackId]
        ? s.containerFiles[originalAction.data.serviceStackId]
        : {};
      return ({
        ...s,
        containerFiles: {
          ...s.containerFiles,
          [originalAction?.data?.serviceStackId]: {
            ...serviceStackFiles,
            [originalAction?.data?.filePath]: data
          }
        }
      })
    }
  ),
  on(getBackupsSuccess, (s, { data, originalAction }) => {
    return {
      ...s,
      backups: {
        ...s.backups,
        [originalAction.data.id]: data
      }
    };
  }),
  on(getProjectBackupsSuccess, (s, { data, originalAction }) => {
    return {
      ...s,
      projectBackups: {
        ...s.projectBackups,
        [originalAction.data.projectId]: {
          ...data,
          sort: originalAction.data.sort,
          offset: originalAction.data.offset || 0
        }
      }
    };
  }),
  on(setBackupConfigSuccess, (s, { originalAction }) => {
    return {
      ...s,
      backups: {
        ...s.backups,
        [originalAction.data.serviceId]: {
          ...s.backups[originalAction.data.serviceId],
          ...originalAction.data.config
        }
      }
    };
  }),
  on(deleteBackupSuccess, (s, { data }) => {
    // deletes from the project page may target a stack whose list was never loaded here
    if (!s.backups[data.serviceId]) {
      return s;
    }
    return {
      ...s,
      backups: {
        ...s.backups,
        [data.serviceId]: {
          ...s.backups[data.serviceId],
          files: s.backups[data.serviceId]?.files.filter((itm) => itm.name !== data.id)
        }
      }
    };
  }),
  on(zefResetState, () => initialState)
);

export function serviceStackBaseReducer(
  state: ServiceStackBaseState,
  action: ServiceStackBaseActionUnion
) {
  return actionReducer(state, action);
}
